<template>
      <vue-page-transition name="fade-in-down">
      <v-content class="bg-content">
        
  <div class="wrap">
    <header class="top">
          <div class="toolbar">
      <div class="brand">
        <span class="logo">🧠 </span>
        <div>
          <h3>PRG AI</h3>
          <small>Cogneetiv AI Enhanced</small>
        </div>
      </div>
    </div>

    
<div class="status">
  <button
    class="level level-btn"
    @click="openGamify"
    type="button"
    aria-label="Open Gamification Dashboard"
    title="Open Gamification Dashboard"
  >
    Level {{ level }} · {{ xp }} XP
    <div class="bar">
      <div class="fill" :style="{ width: (progress * 100) + '%' }"></div>
    </div>
  </button>

  <button class="level level-btn" @click="openOverlay('archive')">Archive</button>
  <button class="level level-btn" @click="openOverlay('neural')">Neural Brain</button>
  <button class="level level-btn" @click="toggleIdle" :title="isIdle ? 'Close Avatar' : 'Avatar'">
    {{ isIdle ? 'Close Avatar' : 'Avatar' }}
  </button>
  <h5 :class="['overlay-title', overlayKey]">
  {{ overlayKey === 'archive'
      ? '🧠 Neural Archive'
      : overlayKey === 'neural'
        ? '⚡ Neural Brain'
        : '📊 Dashboard' }}
</h5>
</div>
    </header>
 <div v-if="isIdle" class="idle-hero">
          <GlowingSphere
            :size="340"
            :listening="listening"
            :thinking="thinking"
            :responding="responding"
          />
          <div
            class="live-preview live-preview--avatar"
            v-if="previewTranscript && listening"
          >
            🎙️ {{ previewTranscript }}
          </div>
<button
  class="big-mic"
  :class="{ on: listening, arming: isArming && !listening }"
  type="button"
  :title="listening ? 'Stop listening' : (isArming ? 'Arming…' : 'Start speaking')"
  @click.stop="startModeVoice(mode || 'chat')"
>
  🎙️ {{ listening ? 'Stop' : (isArming ? 'Arming…' : 'Speak') }}
</button>
<button
  class="fab-mic"
  :class="{ on: listening, arming: isArming && !listening }"
  type="button"
  :title="listening ? 'Stop listening' : (isArming ? 'Arming…' : 'Start speaking')"
  @click.stop="startModeVoice(mode || 'chat')"
>
  🎙️ <span class="label">{{ listening ? 'Stop' : (isArming ? 'Arming…' : 'Speak') }}</span>
</button>


        </div>
        <div v-else>
    <main class="grid">

      <aside class="modes">
        <h3>AI Modes</h3>

        <button
          v-for="m in modes"
          :key="m.key"
          class="card"
          :class="{ active: mode === m.key, open: mode === m.key }"
          @click="onSelectMode(m.key)"
          :aria-pressed="String(mode === m.key)"
        >
          <div class="icon">{{ m.icon }}</div>

          <div class="meta">
            <b>{{ m.title }}</b>
            <small>{{ m.desc }}</small>
          </div>

          <button
            class="mini-mic"
            type="button"
            title="Start voice for this mode"
            @click.stop="startModeVoice(m.key)"
          >🎙️</button>

          <transition name="card-open">
            <div v-if="mode === m.key" class="card-open-body">
              <p class="hint">{{ modeHints[m.key] }}</p>
              <div class="quick-actions">
                <button type="button" class="qa" @click.stop="focusForm()">Focus input</button>
                <button type="button" class="qa" @click.stop="startModeVoice(m.key)">
                  {{ listening ? 'Stop listening' : 'Start listening' }}
                </button>
              </div>
            </div>
          </transition>
        </button>
      </aside>

 <section class="stage hero-sphere">
    <GlowingSphere
      :size="260"
      :listening="listening"
      :thinking="thinking"
      :responding="responding"
    />
    <button
      class="fab-mic"
      :class="{ on: listening }"
      type="button"
      :title="listening ? 'Stop listening' : 'Start speaking'"
      @click.stop="startModeVoice(mode || 'chat')"
    >
      🎙️ <span class="label">{{ listening ? 'Stop' : 'Speak' }}</span>
    </button>

    <br />
    <br />
    <div class="panel">
<div v-if="currentConv" class="active-conv-id" :title="currentConv">
  Conversation: {{ currentConv }}
</div>

          <div v-if="error" class="error">🔴 {{ error }}</div>
                
          <div class="chat" v-if="mode === 'chat'">
            <div class="messages" ref="messages">
              <div v-for="(m, i) in messages" :key="i" :class="['msg', m.role]">
                <p>{{ m.content }}</p>
              </div>
            </div>
          </div>

<div v-if="research.summary" class="summary-box">
  <h4>AI Summary</h4>
  <p>{{ research.summary }}</p>
</div>
              <div v-if="mode==='research'" class="research">
                <label>Search Query</label>
<div class="research-row">
  <input
    ref="researchInput"
    v-model="research.query"
    placeholder="What should I research on Google?"
    @keyup.enter="runGoogleSearch"
  />

  <v-btn
    class="ml-2"
    color="primary"
    :disabled="!research.query || !research.query.trim() || researchCountdown > 0"
    @click="runGoogleSearch"
  >
    <v-icon left small>mdi-magnify</v-icon>
    Search
  </v-btn>
  <span v-if="researchCountdown > 0" class="ml-2 countdown-label">
   Submitting in {{ researchCountdown }}s…
 </span>
</div>

                <div class="row2 research-actions">
                  <button class="btn" @click="collectGoogleResults">📥 Collect Results</button>
                  <button class="btn" :disabled="!research.results.length" @click="saveResearchToArchiveAndBrain">
                    💾 Save to Archive + Brain
                  </button>
                  <button class="btn ghost" :disabled="!research.results.length" @click="summarizeResearch">
                    🧠 Summarize with AI
                  </button>
                </div>
                  <section v-show="mode === 'research'" class="mode-research">
      <AiReporter
   ref="researcher"
   @report-finished="onReporterFinished"
   @sources-collected="onReporterSources"
   @results="onReporterSources"
/>
    </section>

                <div class="google-cse-wrapper">
                  <div class="gcse-searchbox" id="cse-search"></div>
                  <div class="gcse-searchresults" id="cse-results"></div>
                </div>

<div v-if="research.results.length" class="results">
  <h4>Collected Results ({{ research.results.length }})</h4>
  <ul>
    <li v-for="(r, idx) in research.results" :key="'r-'+idx">
      <a :href="r.link" target="_blank" rel="noopener">{{ r.title }}</a>
      <p class="snippet">{{ r.snippet }}</p>
    </li>
  </ul>
</div>
              </div>
<form class="form" @submit.prevent="submit">
  <template v-if="mode === 'chat'">
    <label>Message</label>
    <input
      ref="chatInput"
      v-model="form.chat.message"
      placeholder="Ask Chat AI anything…"
    />
  </template>

            <template v-else-if="mode === 'image'">
              <label>Prompt</label>
              <input
                ref="imagePrompt"
                v-model="form.image.prompt"
                placeholder="Describe the image you want to generate…"
              />
              <div class="row2">
                <label>Size
                  <select v-model="form.image.size">
                    <option>1024x1024</option>
                    <option>1024x1792</option>
                    <option>1792x1024</option>
                  </select>
                </label>
                <label>Style
                  <select v-model="form.image.style">
                    <option>photorealistic</option>
                    <option>illustration</option>
                    <option>cinematic ui</option>
                  </select>
                </label>
              </div>
<div class="image-preview" v-if="form.image.generated.length">
  <h4>Generated Image{{ form.image.generated.length > 1 ? 's' : '' }}</h4>

  <div class="image-grid">
    <figure v-for="(u, i) in form.image.generated" :key="'gen-'+i" class="image-cell">
      <img :src="u" :alt="`Generated image ${i+1}`" />
      <figcaption>
        <button type="button" class="btn" @click="downloadImage(u, i)">⬇️ Download</button>
        <a :href="u" target="_blank" rel="noopener" class="btn ghost">Open</a>
      </figcaption>
    </figure>
  </div>

  <div class="row2">
    <button type="button" class="btn" @click="saveGeneratedImages">💾 Save to Archive + Brain</button>
    <button type="button" class="btn ghost" @click="clearGeneratedImages">🧹 Clear</button>
  </div>
</div>

            </template>

            <template v-else-if="mode === 'video'">
              <label>Concept</label>
              <input
                ref="videoPrompt"
                v-model="form.video.prompt"
                placeholder="Describe the short video you want the AI to plan…"
              />
              <label>Duration (sec)</label>
              <input v-model.number="form.video.duration" type="number" min="3" max="60" />
            </template>

            <template v-else-if="mode === 'storyboard'">
              <label>Scene / Story idea</label>
              <input
                ref="boardPrompt"
                v-model="form.board.prompt"
                placeholder="Describe the scene(s) to storyboard…"
              />
              <label>Shots (comma-separated)</label>
              <input v-model="form.board.shots" placeholder="wide, close-up, cutaway…" />
            </template>

            <div class="input">
    <button
      type="button"
      class="icon"
      @click="toggleMic"
      :title="listening ? 'Stop' : 'Speak'"
    >🎙️</button>

    <button
      class="icon"
      type="submit"
      title="Send/Generate"
      :disabled="isSubmitting || thinking || responding"
      :aria-busy="isSubmitting || thinking || responding"
    >📨</button>
  </div>
<VoiceVisualizer
  :listening="listening"
  :responding="responding"
  :thinking="thinking"
/>

          </form>
        </div>
      </section>
    </main>

          <!-- <transition name="overlay-fade">
            <div v-if="showOverlay" class="overlay-mask" @click.self="closeOverlay">
              <div class="overlay-card">
                <header class="overlay-header">
                  <h4>
                    {{
                      overlayKey === 'archive'
                        ? 'Neural Archive'
                        : overlayKey === 'neural'
                          ? 'Neural Brain'
                          : 'AI Gamification'
                    }}
                  </h4>
                  <button class="close" @click="closeOverlay" aria-label="Close overlay">✕</button>
                </header>
                <div class="overlay-body">
                  <keep-alive>
                    <component :is="overlayComp" v-if="overlayComp" />
                  </keep-alive>
                  <div v-if="overlayError" class="overlay-error">⚠️ {{ overlayError }}</div>
                </div>
              </div>
            </div>
          </transition> -->
        </div>
<!-- Keep one of these; remove the duplicate copy -->
<transition name="overlay-fade">
  <div v-if="showOverlay" class="overlay-mask" @click.self="closeOverlay">
    <div class="overlay-card">
      <header class="overlay-header">
        <h4>{{ overlayKey === 'archive' ? 'Neural Archive' : (overlayKey === 'neural' ? 'Neural Brain' : 'AI Gamification') }}</h4>
        <button class="close" @click="closeOverlay" aria-label="Close overlay">✕</button>
      </header>
      <div class="overlay-body">
        <keep-alive>
          <component :is="overlayComp" v-if="overlayComp" />
        </keep-alive>
        <div v-if="overlayError" class="overlay-error">⚠️ {{ overlayError }}</div>
      </div>
    </div>
  </div>
</transition>

  </div>
      </v-content>
      </vue-page-transition>
</template>

<script>
import GlowingSphere from "./GlowingSphere.vue";
import VoiceVisualizer from "./VoiceVisualizerNew.vue";
import { getSpeechRecognition, speak } from "../utils/speech";
import { ArchiveAPI, NeuralAPI } from "../utils/storage"; // NeuralAPI removed
import { AI, basicKeywords } from "../utils/ai";
import AiReporter from './AIReporter.vue'
export default {
  name: "AIDashboard",
  components: { GlowingSphere, VoiceVisualizer, AiReporter },
  data() {
    return {
      error: "",
      recognition: null,
      mediaStream: null,
      currentConv: null,
      researchSubmitTimer: null,
      researchCountdownTimer: null,
      researchCountdown: 0,
      messages: [],
            userInput: '',
      lastNonResearch: '',
      maxListeningMs: 15000, // 15s
        silenceSubmitDelayMs: 2000, // 2s

      modes: [
        { key: "chat",       title: "Chat",       desc: "AI",      icon: "💬" },
        { key: 'research', title: 'Research',  desc: 'Google search + collect', icon: '🔎' }, // <= required
        { key: "image",      title: "Image",      desc: "AI image generation",    icon: "🖼️" },
        // { key: "video",      title: "Video",      desc: "Video content planning", icon: "🎬" },
        // { key: "storyboard", title: "Storyboard", desc: "Visual narrative",       icon: "📚" },
      ],
      activeMode: 'default',
      modeHints: {
        chat: "Speak or type your message. Press Enter to send.",
        research: "Enter a query, run Google Search, then Collect & Save.",
        image: "Describe the image. You can dictate details by voice.",
        video: "Explain the video concept and desired duration.",
        storyboard: "Describe scenes; list shots comma-separated.",
      },
      form: {
        chat: { message: "" },
        image: { prompt: "", size: "1024x1024", style: "photorealistic", generated: [] },
        video: { prompt: "", duration: 8 },
        board: { prompt: "", shots: "" },
      },
      autoPersist: { enabled: false, saved: false },
      previewTranscript: "",
      silenceTimer: null,
      autoSubmitDelay: 3000,
      autoSubmitArmed: false,
      lastVoiceHadContent: false,
      uiCollapsed: true,
      voiceRouteTarget: null,     // 'chat' | 'research' | 'image' | null
pendingOpenTimer: null,     // setTimeout handle
heardUtterance: false,      // flip to true once we hear final text 
isArming: false,
isSubmitting: false,
      // Overlay state
      showOverlay: false,
      overlayKey: null,     // 'archive' | 'neural'
      overlayComp: null,    // resolved component
      overlayError: "",
      isIdle: true,
      research: {
        query: "",
        results: [], // [{title, link, snippet}]
        cseLoaded: false,
        summary: "", // AI summary of results
      }
    };
  },
  computed: {
 mode() { return this.$store.state.mode; },
  xp() { return this.$store.state.xp; },
  level() { return this.$store.state.level; },
  progress() { return this.$store.getters.levelProgress; },
  listening() { return this.$store.state.listening; },
  thinking() { return this.$store.state.thinking; },
  responding() { return this.$store.state.responding; },
  sphereSize() {
    return this.isIdle ? 360 : 200;
  },
  },
watch: {
  showOverlay(v) {
    document.documentElement.style.overflow = v ? "hidden" : "";
    document.body.style.overflow = v ? "hidden" : "";
  },
  mode(val /*, oldVal */) {
    if (val === "research") this.loadGoogleCSE();
    if (this.isIdle && val !== "chat") {
      this.deactivateIdle();
    }
  },
  // Auto-persist once results appear (e.g., after CSE/AiReporter fills them)
  'research.results'(arr) {
    if (Array.isArray(arr) && arr.length) {
      this.autoPersistResearchIfReady(); // saves to Archive + Neural Brain once
    }
  }
},
  mounted() {
    this.$nextTick(() => this.$refs.researchInput && this.$refs.researchInput.focus());
    if (!this.mode) this.$store.commit('SET_MODE', 'chat');
   this.$nextTick(() => this.$refs.cmd && this.$refs.cmd.focus());
    this.recognition = getSpeechRecognition();
    if (this.recognition) {
      this.recognition.interimResults = true;
      this.recognition.continuous = true; // IMPORTANT for our 3s logic

this.recognition.onstart = () => {
  this.isArming = false;                // <— clear arming when mic truly starts
  this.$store.dispatch("startListening");
  this.autoSubmitArmed = true;
  this.lastVoiceHadContent = false;
  this.resetSilenceTimer();
};

this.recognition.onend = () => {
  this.isArming = false;                // <— ensure arming cleared
  this.$store.dispatch("stopListening");
  if (this.autoSubmitArmed && this.lastVoiceHadContent) {
    this.finishVoiceAndSubmit();
  } else {
    this.clearSilenceTimer();
  }
  this.previewTranscript = "";
};

this.recognition.onerror = (e) => {
  this.isArming = false;                // <— ensure arming cleared on error
  this.error = `Voice recognition error: ${e.error}`;
  this.clearSilenceTimer();
};

      this.recognition.onspeechstart = () => {
        this.lastVoiceHadContent = true;
        this.resetSilenceTimer();
      };

      this.recognition.onspeechend = () => {
        // User stopped talking—start 3s countdown
        this.resetSilenceTimer();
      };

this.recognition.onresult = (e) => {
  let finalText = "";
  for (let i = e.resultIndex; i < e.results.length; i++) {
    const seg = e.results[i][0].transcript;
    if (e.results[i].isFinal) finalText += seg;
    else this.previewTranscript = seg;
  }
  if (!finalText) return;
  this.heardUtterance = true;
  const { target, cleaned, delayMs } = this.parseVoiceIntent(finalText);
  this.voiceRouteTarget = target; // <-- remember intended mode

  if (target === "image") {
    this.form.image.prompt = this.smartAppend(this.form.image.prompt, cleaned || "");
    this.onSelectMode("image");
    if (cleaned) this.submitImageWithDelay(delayMs || 2000);
  } else if (target === "research") {
    // Open Research, show the text, and submit after 5s
    const q = this.smartAppend(this.research.query, cleaned || "");
    this.scheduleResearchSubmit(q, 5000);
  } else {
    this.form.chat.message = this.smartAppend(this.form.chat.message, cleaned || finalText);
    this.onSelectMode("chat");
    if (delayMs === 0) this.$nextTick(() => this.submit());
  }

  this.previewTranscript = "";
  try { if (this.listening) this.recognition.stop(); } catch (e) { void e; }
  this.lastVoiceHadContent = true;
  this.resetSilenceTimer();
};




    }
 const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        this.$nextTick(() => this.$refs.cmd && this.$refs.cmd.focus())
      }
    }
window.addEventListener('keydown', this.onIdleHotkey);
    window.addEventListener("keydown", this.onKey);
    this.$once('hook:beforeDestroy', () => window.removeEventListener('keydown', onKey))
  },
beforeDestroy() {
  window.removeEventListener("keydown", this.onKey);
  window.removeEventListener("keydown", this.onIdleHotkey); // ← new
  if (typeof this.clearSilenceTimer === "function") this.clearSilenceTimer();
  if (this.researchSubmitTimer) clearTimeout(this.researchSubmitTimer);
  if (this.researchCountdownTimer) clearInterval(this.researchCountdownTimer);
  const r = this.$refs && this.$refs.researcher;
 if (r && r.$off) {
   r.$off('report-finished', this.onReporterFinished);
   r.$off('sources-collected', this.onReporterSources);
   r.$off('results', this.onReporterSources);
 }
},


  methods: {
    onKey(e) { if (e.key === "Escape" && this.showOverlay) this.closeOverlay(); },

    async openOverlay(key) {
      this.overlayKey = key;
      this.overlayComp = null;
      this.overlayError = "";
      this.showOverlay = true;
      try {
        let mod;
        if (key === "archive") {
          try { mod = (await import(/* webpackChunkName: "archive-overlay" */ "../views/Archive.vue")).default; }
          catch { mod = (await import(/* webpackChunkName: "archive-overlay" */ "./Archive.vue")).default; }
        } else if (key === "neural") {
          try { mod = (await import(/* webpackChunkName: "neural-overlay" */ "../views/NeuralNew.vue")).default; }
          catch { mod = (await import(/* webpackChunkName: "neural-overlay" */ "./NeuralNew.vue")).default; }
        } else if (key === "gamify") {
          // NEW: try component location first
          try { mod = (await import(/* webpackChunkName: "gamify-overlay" */ "./GamifyOverlay.vue")).default; }
          catch { mod = (await import(/* webpackChunkName: "gamify-overlay" */ "../views/GamifyOverlay.vue")).default; }
        }
        this.overlayComp = mod;
      } catch (e) {
        this.overlayError = e.message || "Failed to load overlay.";
      }
    },
scheduleResearchSubmit(q, delayMs = 5000) {
  // Clear previous timers (latest command wins)
  if (this.researchSubmitTimer) clearTimeout(this.researchSubmitTimer);
  if (this.researchCountdownTimer) clearInterval(this.researchCountdownTimer);
  this.researchSubmitTimer = null;
  this.researchCountdownTimer = null;

  // Exit Avatar view to show the form/results panel
  this.deactivateIdle();

  // Arm auto-persist for this query
  this.autoPersist = { enabled: true, saved: false };

  // Reset old results to avoid accidentally saving stale ones
  this.research.results = [];

  // Open Research mode, show query
  this.research.query = String(q || "").trim();
  this.onSelectMode("research");
  if (!this.research.cseLoaded) this.loadGoogleCSE();

  // Make sure we have a conversation to append to
  this.ensureResearchConversation(this.research.query);

  // Countdown UI
  const secs = Math.max(1, Math.round(delayMs / 1000));
  this.researchCountdown = secs;
  this.researchCountdownTimer = setInterval(() => {
    this.researchCountdown = Math.max(0, this.researchCountdown - 1);
    if (this.researchCountdown <= 0) {
      clearInterval(this.researchCountdownTimer);
      this.researchCountdownTimer = null;
    }
  }, 1000);

  // Nice heads-up line
  this.$nextTick(() => {
    if (this.research.query) {
      this.notify(`🔎 Researching “${this.research.query}” in ${secs}s…`);
    }
  });

  // Schedule actual submit
  this.researchSubmitTimer = setTimeout(() => {
    this.researchSubmitTimer = null;
    if (!this.research.query || !this.research.query.trim()) return;
    this.runGoogleSearch();
  }, delayMs);
},

ensureResearchConversation(queryText = "") {
  // Create a conversation up-front so all follow-ups append to it
  if (!this.currentConv) {
    const created = ArchiveAPI.create({
      mode: "research",
      userText: String(queryText || "").trim(),
      aiText: "(auto research started)",
      keywords: ["research", "google", "cse"]
    });
    this.currentConv = created && created.id ? created.id : created;
  } else if (queryText) {
    // Log the new query in the same thread
    ArchiveAPI.appendMessage(
      this.currentConv,
      { role: "user", content: String(queryText).trim() },
      ["research", "google", "cse"]
    );
  }
},
async autoPersistResearchIfReady(/* source = "watch" */) {
  if (!this.autoPersist?.enabled || this.autoPersist?.saved) return;
  const arr = Array.isArray(this.research.results) ? this.research.results : [];
  if (!arr.length) return;

  await this.saveResearchToArchiveAndBrain();
  this.autoPersist.saved = true;
  this.notify(`✅ Saved ${arr.length} result${arr.length === 1 ? "" : "s"} to Archive + Neural Brain.`);
},
// Convert various reporter payload shapes into [{title, link, snippet}]
normalizeReporterResults(payload) {
  const out = [];

  // If payload is already an array of {title, link, snippet}
  if (Array.isArray(payload)) {
    payload.forEach(r => {
      const title = String(r.title || "").trim();
      const link = String(r.link || r.url || "").trim();
      const snippet = String(r.snippet || r.summary || r.finding || "").trim();
      if (title && link) out.push({ title, link, snippet });
    });
    return out;
  }

  // If payload is an object with known keys
  if (payload && typeof payload === "object") {
    // e.g., { results: [...], sources: [...], steps: [...] }
    const buckets = []
      .concat(payload.results || [])
      .concat(payload.sources || [])
      .concat(payload.steps || []);

    buckets.forEach(r => {
      const title = String(r.title || r.name || "").trim();
      const link = String(r.link || r.url || "").trim();
      const snippet = String(r.snippet || r.summary || r.finding || r.quote || "").trim();
      if (title && link) out.push({ title, link, snippet });
    });
  }

  return out;
},

onReporterSources(evt) {
  // evt may be { results } or { sources }
  const maybe = evt && (evt.results || evt.sources || evt);
  const normalized = this.normalizeReporterResults(maybe);
  if (normalized.length) {
    this.research.results = normalized;
    this.autoPersistResearchIfReady(); // Archive + Neural Brain (once)
  }
},

onReporterFinished(payload) {
  const normalized = this.normalizeReporterResults(payload);
  // If finishing payload gives us better/longer set, prefer it
  if (normalized.length) this.research.results = normalized;
  this.autoPersistResearchIfReady(); // Archive + Neural Brain (once)
},
armReporterHooks() {
  if (this.__reporterHooked) return;
  const r = this.$refs && this.$refs.researcher;
  if (!r || !r.$on) return;

  r.$on('report-finished', this.onReporterFinished);
  r.$on('sources-collected', this.onReporterSources);
  r.$on('results', this.onReporterSources);

  this.__reporterHooked = true;
},

    toggleIdle() {
      this.isIdle = !this.isIdle;
      this.persistIdlePref();
      // optional UX nicety: scroll to top when entering stage
      if (!this.isIdle) this.$nextTick(() => window.scrollTo(0, 0));
    },
    activateIdle() {
      if (!this.isIdle) {
        this.isIdle = true;
        this.persistIdlePref();
      }
    },
    deactivateIdle() {
      if (this.isIdle) {
        this.isIdle = false;
        this.persistIdlePref();
      }
    },
    persistIdlePref() {
try {
  localStorage.setItem("ui.isIdle", JSON.stringify(this.isIdle));
} catch (e) {
  // storage might be blocked (private mode / quota)
  void e; // explicit no-op to satisfy eslint(no-empty / no-unused-vars)
}
      this.$emit("idle-change", this.isIdle); // in case a parent wants to react
    },
    onIdleHotkey(e) {
      // Toggle with "i" unless typing in an input element
      const tag = (e.target && e.target.tagName || "").toLowerCase();
      if (/input|textarea|select/.test(tag)) return;
      if (e.key === "i" || e.key === "I") this.toggleIdle();
      // Escape closes idle view if open (optional)
      if (e.key === "Escape" && this.isIdle === true) this.deactivateIdle();
    },
    // ADD inside methods: { ... }
parseVoiceIntent(text = "") {
  const s = String(text).trim();
  const low = s.toLowerCase();

  // IMAGE: "create|make|generate (an) image|picture|banner|logo|poster|art|graphic …"
  let m = s.match(/^(?:create|make|generate)\s+(?:an?\s+)?(?:image|picture|banner|logo|poster|art|graphic)\s*(.*)$/i);
  if (m) {
    return { target: "image", cleaned: (m[1] || "").trim(), delayMs: 2000 };
  }

  // RESEARCH: "research|google|browse|search( for)?|look up|find …"
  m = s.match(/^(?:research|google|browse|search(?:\s+for)?|look\s+up|find)\s+(.*)$/i);
  if (m) {
    return { target: "research", cleaned: (m[1] || "").trim(), delayMs: 5000 };
  }

  // Bare openers (no payload)
  if (/^(research|google|browse)$/i.test(low)) {
    return { target: "research", cleaned: "", delayMs: null };
  }

  // Fallbacks
  const target = this.chooseModeFromText(s);
  return { target, cleaned: s, delayMs: target === "chat" ? 0 : null };
},

// ADD inside methods: { ... }
submitImageWithDelay(ms = 2000) {
  if (!this.form.image.prompt.trim()) return;
  setTimeout(() => {
    if (this.mode !== "image") this.onSelectMode("image");
    this.$nextTick(() => this.submit());
  }, ms);
},

routeVoiceCommand(phraseRaw = "") {
  const s = String(phraseRaw || "").trim();
  if (!s) return false;
  const low = s.toLowerCase();

  // 1) “create image …” → switch to Image, ask prompt if needed
  if (/^(create (an )?image|image mode|make (an )?image)/i.test(low)) {
    this.onSelectMode("image");
    // If user gave a subject after "create image", extract after that
    const m = s.match(/^(?:create (?:an )?image|image mode|make (?:an )?image)\s*(.*)$/i);
    const subject = (m && m[1] || "").trim();

    if (subject) {
      this.form.image.prompt = this.smartAppend(this.form.image.prompt, subject);
    } else {
      // Ask, then keep listening to capture their prompt
      this.messages.push({
        role: "assistant",
        content: "What image would you like to create?"
      });
      // re-arm listening smoothly
      if (!this.listening) this.startModeVoice("image");
    }
    return true;
  }

  // 2) “research … / search google for … / google …” → Research + run
  const researchMatch =
    low.match(/^(?:research|search(?: google)? for|google)\s+(.*)$/i);
  if (researchMatch && researchMatch[1]) {
    const q = researchMatch[1].trim();
    this.scheduleResearchSubmit(q, 5000);
    return true;
  }
  if (/^(?:research|open research)$/.test(low)) {
    this.onSelectMode("research");
    if (!this.listening) this.startModeVoice("research");
    return true;
  }

  // 3) “chat / explain … / tell me …” → Chat + fill message
  if (/^(?:chat|open chat)$/.test(low)) {
    this.onSelectMode("chat");
    if (!this.listening) this.startModeVoice("chat");
    return true;
  }
  if (/^(?:explain|tell me|what is|who is|how do|why is|please explain)/i.test(low)) {
    this.onSelectMode("chat");
    this.form.chat.message = this.smartAppend(this.form.chat.message, s);
    // optional: auto-submit for direct questions
    this.$nextTick(() => this.submit());
    return true;
  }

  // 4) explicit “open image”
  if (/^open image$/.test(low)) { this.onSelectMode("image"); return true; }

  // Not handled specially
  return false;
},


// ADD inside methods:{ ... }
chooseModeFromText(text = "") {
  const s = String(text).toLowerCase();

  // strong research intents
  if (/(^|\b)(research|google|search for|look up|find)\b/.test(s)) return "research";

  // image intents
  if (/(^|\b)(create|make|generate)\b.*\b(image|picture|banner|logo|poster|art|graphic)\b/.test(s)) return "image";
  if (/\b(inpaint|outpaint|upscale|variations?)\b/.test(s)) return "image";

  // default to chat for Q&A phrasing
  if (/\b(what|who|how|why|explain|tell me|summarize|define)\b/.test(s)) return "chat";

  // fallback
  return "chat";
},

notify(msg) {
  // Light-touch: surface as an assistant system line + optional console
  if (msg) this.messages.push({ role: "assistant", content: msg });
try {
  console.info("[AIDashboard]", msg);
} catch (e) {
  console.warn("Console info failed:", e);
}

},

openModeWithDelay(target, ms = 2000) {
  const label = target === "research" ? "Research"
              : target === "image"    ? "Image"
              : "Chat";
  this.notify(`Opening ${label} Mode in ${Math.round(ms/1000)}s…`);

  if (this.pendingOpenTimer) clearTimeout(this.pendingOpenTimer);
  this.pendingOpenTimer = setTimeout(() => {
    // open the UI (leave idle hero), focus, then optionally auto-run
    this.onSelectMode(target);

    // Auto actions per mode
    if (target === "research" && this.research.query.trim()) {
      // ensure CSE loaded then run search
      if (!this.research.cseLoaded) this.loadGoogleCSE();
      setTimeout(() => this.runGoogleSearch(), 200);
    } else if (target === "chat" && this.form.chat.message.trim()) {
      // submit chat immediately
      this.$nextTick(() => this.submit());
    }

    this.pendingOpenTimer = null;
  }, ms);
},

    openGamify() {
      // Open using the SAME overlay flow as archive/neural
      this.openOverlay("gamify");
    },

    closeOverlay() {
      this.showOverlay = false;
      this.overlayKey = null;
    },


buildSavedContext(userText) {
  const keys = basicKeywords(userText, { limit: 6, minLength: 4 });
  const keySet = new Set(keys.map(k => String(k).toLowerCase()));

  // ---- Archive scan (recent & keyword overlap)
  const convs = (ArchiveAPI.list() || []).slice(0, 40); // limit for speed
  const scored = convs
    .map(c => {
      const kws = (c.keywords || []).map(k => String(k).toLowerCase());
      const overlap = kws.filter(k => keySet.has(k)).length;
      return { c, overlap };
    })
    .filter(x => x.overlap > 0)
    .sort((a, b) => b.overlap - a.overlap)
    .slice(0, 6)
    .map(({ c }) => {
      const last = (c.messages || []).slice(-1)[0];
      const lastLine = last ? `${last.role}: ${last.content}` : "";
      const stamp = c.updatedAt || c.createdAt;
      const ts = stamp ? new Date(stamp).toLocaleString() : "unknown time";
      return `• ${c.title || c.mode} (${ts}): ${c.summary || lastLine}`;
    });

  // ---- Neural Brain (string search)
  let brainMatches = [];
  try {
    const q = keys.join(" ");
    brainMatches = (NeuralAPI.search(q) || [])
      .slice(0, 6)
      .map(r => {
        if (r.type === "web_research") {
          const top = (r.records || [])
            .slice(0, 2)
            .map(rr => `${rr.title} — ${rr.link}`)
            .join(" | ");
          return `• research: ${r.query} ⇒ ${top}`;
        } else if (r.type === "web_summary") {
          return `• summary: ${r.query} ⇒ ${String(r.summary).slice(0, 180)}…`;
        } else if (r.type === "image_generation") {
          const n = (r.urls || []).length;
          return `• image: ${r.prompt} [${n} url${n === 1 ? "" : "s"}]`;
        }
        return `• ${r.type || "note"}: ${JSON.stringify(r).slice(0, 160)}…`;
      });
  } catch (e) {
    console.warn("NeuralAPI.search failed:", e);
  }

  if (!scored.length && !brainMatches.length) return "";

  return [
    "CONTEXT FROM ARCHIVE & NEURAL BRAIN (use if relevant):",
    scored.join("\n"),
    brainMatches.join("\n")
  ]
    .filter(Boolean)
    .join("\n");
},
tryVoiceCommand(phraseRaw = "") {
    const phrase = String(phraseRaw).trim();
    if (!phrase) return false;

    const lower = phrase.toLowerCase();

    // Quick helpers
    const goChat = (text) => {
      this.onSelectMode("chat");
      this.form.chat.message = this.smartAppend(this.form.chat.message, text);
      // Submit immediately for simple requests
      this.submit();
    };

    const goResearch = (q) => {
      this.onSelectMode("research");
      // If user said only "research", do nothing until they add a query
      if (q) {
        this.research.query = q.trim();
        // If CSE isn't loaded yet, load and delay search slightly
        if (!this.research.cseLoaded) this.loadGoogleCSE();
        setTimeout(() => this.runGoogleSearch(), 200);
      }
    };

    // 1) Explicit "research..." style phrases
    // Examples: "research quantum dots", "google superconductivity",
    // "search for transformers paper", "find the inventor of ..."
    const researchMatchers = [
      /^research\s+(.+)/i,
      /^google\s+(.+)/i,
      /^search\s+for\s+(.+)/i,
      /^search\s+(.+)/i,
      /^look\s+up\s+(.+)/i,
      /^find\s+(.+)/i
    ];
    for (const rx of researchMatchers) {
      const m = phrase.match(rx);
      if (m && m[1]) {
   this.scheduleResearchSubmit(m[1], 5000);
   return true;
  }
    }
    // User just said "research" (no query): open panel, focus input
    if (/^research!?$/.test(lower)) { goResearch(""); return true; }

    // 2) Mode switching by name
    if (/^chat!?$/.test(lower)) { this.onSelectMode("chat"); this.focusForm(); return true; }
    if (/^image!?$/.test(lower)) { this.onSelectMode("image"); this.focusForm(); return true; }
    if (/^dashboard!?$/.test(lower)) { this.onSelectMode("chat"); this.focusForm(); return true; }

    // 3) Generic teach/explain/what/how questions → Chat
    // e.g. "please explain quantum physics", "what is diffusion?"
    if (
      /\b(explain|what is|what's|tell me|how does|how do|summarize|define)\b/i.test(lower)
    ) {
      goChat(phrase);
      return true;
    }

    // Otherwise: do not intercept (let normal transcript logic run)
    return false;
  },
onSelectMode(key) {
  if (this.mode !== key) {
    this.$store.commit("SET_MODE", key);
    this.$store.commit("SET_FLAGS", { thinking: false, responding: false });
  }
  // OPEN app UI (leave idle)
  this.uiCollapsed = false;

  this.$nextTick(() => {
    this.focusForm();
    const panel = this.$el.querySelector(".panel");
    if (panel) panel.scrollIntoView({ behavior: "smooth", block: "start" });
  });
},

clearGeneratedImages() {
  this.form.image.generated = [];
},

async downloadImage(url, i = 0) {
  try {
    // Open image in a new tab/window
    window.open(url, "_blank", "noopener");

    // Trigger a download in the current window
    const a = document.createElement("a");
    a.href = url;
    a.download = `cogneetiv-image-${i + 1}.png`;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (e) {
    console.error("Failed to open or download image:", e);
  }
},


saveGeneratedImages() {
  const urls = this.form.image.generated || [];
  if (!urls.length) { this.error = "No images to save."; return; }

  const meta = {
    prompt: this.form.image.prompt,
    size: this.form.image.size,
    style: this.form.image.style,
    urls
  };

  // 1) Ensure a conversation exists; record both a user + assistant style line
  if (!this.currentConv) {
    const created = ArchiveAPI.create({
      mode: "image",
      userText: `${meta.prompt} | size:${meta.size} | style:${meta.style}`,
      aiText: urls.join("\n"),
      keywords: ["image","generation", meta.style, meta.size]
    });
    this.currentConv = created && created.id ? created.id : created;
  } else {
    // append assistant with the URLs (keeps convo thread intact)
    ArchiveAPI.appendMessage(
      this.currentConv,
      { role: "assistant", content: `Generated image URL${urls.length>1?"s":""}:\n${urls.join("\n")}` },
      ["image", "generation", meta.style, meta.size]
    );
  }

  // 2) Ingest into Neural Brain
  try {
    NeuralAPI.ingest({
      type: "image_generation",
      iso: new Date().toISOString(),
      prompt: meta.prompt,
      size: meta.size,
      style: meta.style,
      urls
    });
  } catch (e) {
    console.warn("NeuralAPI.ingest(image_generation) failed:", e);
  }

  this.$store.dispatch("addXP", 40);
},

// REPLACE startModeVoice with this
startModeVoice(arg = 5000) {
  if (!this.recognition) { this.error = "Speech recognition is not supported in this browser."; return; }

  // NEW: allow startModeVoice('research') or startModeVoice('chat')
  if (typeof arg === 'string') {
    this.voiceRouteTarget = arg;
  }

  if (this.listening) {
    try {
  this.recognition.stop();
} catch (e) {
  void e; // explicitly acknowledge the error (no-op) to satisfy no-empty
}

    this.isArming = false;
    return;
  }
  const delay = typeof arg === 'number' ? arg : 400; // short delay if target provided
  this.isArming = true;
  this.pendingOpenTimer = setTimeout(() => {
    this.pendingOpenTimer = null;
    // if a target mode was provided, switch now
    if (this.voiceRouteTarget) this.onSelectMode(this.voiceRouteTarget);
    this.toggleMic();
  }, delay);
},





    focusForm() {
      this.$nextTick(() => {
        let el = null;
        if (this.mode === "chat") el = this.$refs.chatInput;
        else if (this.mode === "image") el = this.$refs.imagePrompt;
        else if (this.mode === "video") el = this.$refs.videoPrompt;
        else if (this.mode === "storyboard") el = this.$refs.boardPrompt;
        else if (this.mode === "research") el = this.$refs.researchInput;
        if (el && typeof el.focus === "function") el.focus();
      });
    },

    // ---------- voice helpers (existing) ----------
    clearSilenceTimer() { if (this.silenceTimer) { clearTimeout(this.silenceTimer); this.silenceTimer = null; } },
    resetSilenceTimer() {
      this.clearSilenceTimer();
      if (!this.autoSubmitArmed) return;
      this.silenceTimer = setTimeout(() => { this.finishVoiceAndSubmit(); }, this.autoSubmitDelay);
    },
    flushPreviewToForm() {
      const t = (this.previewTranscript || "").trim();
      if (!t) return;
      if (this.mode === "chat") this.form.chat.message = this.smartAppend(this.form.chat.message, t);
      else if (this.mode === "image") this.form.image.prompt = this.smartAppend(this.form.image.prompt, t);
      else if (this.mode === "video") this.form.video.prompt = this.smartAppend(this.form.video.prompt, t);
      else if (this.mode === "storyboard") this.form.board.prompt = this.smartAppend(this.form.board.prompt, t);
      else if (this.mode === "research") this.research.query = this.smartAppend(this.research.query, t);
      this.previewTranscript = "";
    },
// REPLACE the early part of finishVoiceAndSubmit to avoid double-opening
async finishVoiceAndSubmit() {
  if (!this.autoSubmitArmed) return;
  this.autoSubmitArmed = false; this.clearSilenceTimer();

  // stop listening if still on
try {
  if (this.listening) this.recognition.stop();
} catch (e) {
  console.warn("Recognition stop failed:", e);
}


  // If we already routed from onresult, do nothing here (the delayed open will handle it)
  if (this.heardUtterance && this.voiceRouteTarget) return;

  // Otherwise fall back to original behavior (flush interim and submit in current mode)
  this.flushPreviewToForm();
  if (this.mode === "research" && this.research.query.trim()) {
    if (this.researchSubmitTimer) return;
    // If no scheduled timer (e.g., typed input), submit now.
    this.runGoogleSearch(); return;
  }

  const hasText =
    (this.mode === "chat"       && this.form.chat.message.trim()) ||
    (this.mode === "image"      && this.form.image.prompt.trim()) ||
    (this.mode === "video"      && this.form.video.prompt.trim()) ||
    (this.mode === "storyboard" && this.form.board.prompt.trim());

  if (hasText) await this.submit();
},

    applyTranscript(text, isFinal) {
      if (!isFinal) return;
      if (this.mode === "chat") this.form.chat.message = this.smartAppend(this.form.chat.message, text);
      else if (this.mode === "image") this.form.image.prompt = this.smartAppend(this.form.image.prompt, text);
      else if (this.mode === "video") this.form.video.prompt = this.smartAppend(this.form.video.prompt, text);
      else if (this.mode === "storyboard") this.form.board.prompt = this.smartAppend(this.form.board.prompt, text);
      else if (this.mode === "research") this.research.query = this.smartAppend(this.research.query, text);
      this.$forceUpdate();
    },
    smartAppend(base = "", chunk = "") {
      const a = base.trim(); const b = chunk.trim();
      if (!a) return b;
      if (a.toLowerCase().endsWith(b.toLowerCase())) return a;
      const aw = a.split(/\s+/); const bw = b.split(/\s+/);
      const maxOverlap = Math.min(aw.length, bw.length, 8);
      let k = 0;
      for (let n = maxOverlap; n > 0; n--) {
        const tail = aw.slice(-n).join(" ").toLowerCase();
        const head = bw.slice(0, n).join(" ").toLowerCase();
        if (tail === head) { k = n; break; }
      }
      const addition = bw.slice(k).join(" ");
      return (a + (addition ? " " + addition : "")).trim();
    },

async toggleMic() {
      if (!this.recognition) { this.error = "Speech recognition is not supported in this browser."; return; }
      if (!this.mediaStream) {
        try {
          this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
          window.__cogneetivMicStream = this.mediaStream;
          window.dispatchEvent(new CustomEvent("cog:mic-stream", { detail: this.mediaStream }));
        } catch (e) { console.warn("getUserMedia failed (visualizer will fall back):", e); }
      }
      try {
        if (this.listening) {
          this.autoSubmitArmed = false; this.clearSilenceTimer(); this.recognition.stop(); this.previewTranscript = "";
        } else {
          this.error = ""; this.previewTranscript = "";
          this.autoSubmitArmed = true; this.lastVoiceHadContent = false;
          this.recognition.start(); this.resetSilenceTimer();
        }
      } catch(e) { this.error = "Failed to start speech recognition"; console.error(e); }
    },

 // ---------- Chat/Image/Video/Storyboard submit (unchanged flow) ----------
async submit() {
  // prevent accidental double-fires
  if (this.isSubmitting || this.thinking || this.responding) return;

  let userText = "";
  if (this.mode === "chat") userText = this.form.chat.message.trim();
  else if (this.mode === "image") userText = `${this.form.image.prompt} | size:${this.form.image.size} | style:${this.form.image.style}`.trim();
  else if (this.mode === "video") userText = `${this.form.video.prompt} | duration:${this.form.video.duration}s`.trim();
  else if (this.mode === "storyboard") userText = `${this.form.board.prompt} | shots:${this.form.board.shots}`.trim();
  if (!userText) return;

  // extra guard: if same user line is already the last message, skip
  if (this.mode === "chat") {
    const last = this.messages[this.messages.length - 1];
    if (last && last.role === "user" && last.content === userText) return;
  }

  this.isSubmitting = true;
  try {
    // stop mic to avoid voice re-triggers
    if (this.listening) {
      try { this.recognition.stop(); } catch(e) { /* no-op */ }
      this.previewTranscript = "";
    }

    if (this.mode === "chat") {
      this.messages.push({ role: "user", content: userText });
      this.scrollToBottom();
    }

    this.$store.dispatch("startThinking");

    let result;
    try {
      if (this.mode === "chat") {
        const ctx = this.buildSavedContext(userText);
        const ctxPrompt = ctx ? `${userText}\n\n---\n${ctx}\n---` : userText;
        result = await AI.chat(ctxPrompt);
      } else if (this.mode === "image") {
        result = await AI.image(userText);
      } else if (this.mode === "video") {
        result = await AI.video(userText);
      } else if (this.mode === "storyboard") {
        result = await AI.storyboard(userText);
      }
    } catch (e) {
      this.error = e.message || "OpenAI request failed.";
      this.$store.dispatch("stopResponding");
      return;
    } finally {
      this.$store.dispatch("startResponding");
    }

    const reply = result?.text || "No response.";
    const keywords = result?.keywords || [];

    if (this.mode === "image" && Array.isArray(result?.imageUrls)) {
      this.form.image.generated = result.imageUrls;
    }

    if (this.mode === "chat" || this.mode === "image") {
      // extra guard: don't duplicate assistant line either
      const last = this.messages[this.messages.length - 1];
      if (!(last && last.role === "assistant" && last.content === reply)) {
        this.messages.push({ role: "assistant", content: reply });
        this.scrollToBottom();
      }
      if (this.mode === "chat") speak(reply, null, 1, 1);
    }

    if (!this.currentConv) {
      const created = ArchiveAPI.create({ mode: this.mode, userText, aiText: reply, keywords });
      this.currentConv = created && created.id ? created.id : created;
    } else {
      ArchiveAPI.appendMessage(this.currentConv, { role: "user", content: userText }, keywords);
    }

    this.$store.dispatch("addXP", 25);
    this.$store.dispatch("stopResponding");
    if (this.mode === "chat") this.form.chat.message = "";
  } finally {
    this.isSubmitting = false;
  }
},


    scrollToBottom() {
      this.$nextTick(() => { const el = this.$refs.messages; if (el) el.scrollTop = el.scrollHeight; });
    },
    
loadGoogleCSE() {
  if (this.research.cseLoaded) return;
  if (!window.__gcseLoaded) {
    const script = document.createElement("script");
    script.src = "https://cse.google.com/cse.js?cx=87a5cd3086b3e4db7";
    script.async = true;
    script.onload = () => {
      window.__gcseLoaded = true;
      this.research.cseLoaded = true;
      window.dispatchEvent(new Event('cse:ready'));
      this.$nextTick(() => this.setupResultObserver());
    };
    document.head.appendChild(script);
  } else {
    this.research.cseLoaded = true;
    this.$nextTick(() => this.setupResultObserver());
  }
},


async waitForCseInput(timeout = 4000) {
  const start = Date.now();
  while (Date.now() - start < timeout) {
    const input = document.getElementById("gsc-i-id1") || document.querySelector("input.gsc-input");
    if (input) return input;
    await new Promise(r => setTimeout(r, 50));
  }
  return null;
},
async runGoogleSearch() {
  const q = (this.research?.query || "").trim();
  if (!q) return;

  const reporter = this.$refs?.researcher;
if (reporter?.runReporter) {
   this.armReporterHooks();
   const p = reporter.runReporter(q, { forceOpen: true, speak: true });
   setTimeout(() => this.collectGoogleResults(), 2500);
   return p;
 }
  if (!this.research.cseLoaded) await new Promise(r => window.addEventListener('cse:ready', r, { once: true }));
  const input = await this.waitForCseInput();
  if (!input) {
    window.open(`https://www.google.com/search?q=${encodeURIComponent(q)}`, "_blank", "noopener");
    return;
  }
  input.value = q;
  input.dispatchEvent(new Event("input", { bubbles: true }));
  input.dispatchEvent(new KeyboardEvent("keydown", { key: "Enter", code: "Enter", keyCode: 13, which: 13, bubbles: true }));
  setTimeout(() => this.collectGoogleResults(), 2000);
},

setupResultObserver() {
  const container = document.getElementById("cse-results");
  if (!container || this.__resultObserver) return;

  this.__resultObserver = new MutationObserver(() => this.scrapeCseOnce());
  this.__resultObserver.observe(container, { childList: true, subtree: true });
},
scrapeCseOnce() {
  const container = document.getElementById("cse-results");
  if (!container) return;
  const nodes = container.querySelectorAll(".gsc-webResult.gsc-result");
  const out = [];
  nodes.forEach(n => {
    const linkEl = n.querySelector(".gs-title a");
    const title = (linkEl?.textContent || "").trim();
    const link  = (linkEl?.href || "").trim();
    const snippet = (n.querySelector(".gs-snippet")?.textContent || "").trim();
    if (title && link) out.push({ title, link, snippet });
  });
  if (out.length) this.research.results = out;
  this.autoPersistResearchIfReady("scrape");
},

    collectGoogleResults() {
      const container = document.querySelector("#cse-results");
      if (!container) { this.error = "Google CSE results container not found."; return; }

      const nodes = container.querySelectorAll(".gsc-webResult.gsc-result");
      const out = [];
      nodes.forEach(n => {
        const titleNode = n.querySelector(".gs-title");
        const linkEl = titleNode?.querySelector("a");
        const title = (linkEl?.textContent || titleNode?.textContent || "").trim();
        const link = (linkEl?.href || "").trim();
        const snippet = (n.querySelector(".gs-snippet")?.textContent || "").trim();
        if (title && link) out.push({ title, link, snippet });
      });

      this.research.results = out;
      if (!out.length) this.error = "No results collected. Try scrolling results or refine the query.";
      this.autoPersistResearchIfReady("collect");
    },

    async saveResearchToArchiveAndBrain() {
      if (!this.research.results.length) return;
      const payload = {
        query: this.research.query,
        timestamp: Date.now(),
        results: this.research.results.slice(0, 25) // cap to keep items tidy
      };

      const asText = [
        `🔎 Research Query: ${payload.query}`,
        ...payload.results.map((r, i) => `${i + 1}. ${r.title}\n${r.link}\n${r.snippet}`)
      ].join("\n\n");

      if (!this.currentConv) {
        const created = ArchiveAPI.create({
          mode: "research",
          userText: payload.query,
          aiText: "(research-collected)",
          keywords: ["research", "google", "cse"]
        });
        this.currentConv = created && created.id ? created.id : created;
      }
      ArchiveAPI.appendMessage(this.currentConv, { role: "system", content: asText }, ["research", "google"]);

      try {
        NeuralAPI.ingest({
          type: "web_research",
          query: payload.query,
          records: payload.results
        });
      } catch (e) {
        console.warn("NeuralAPI.ingest failed:", e);
      }

      this.$store.dispatch("addXP", 35);
    },

async summarizeResearch() {
  if (!this.research.results.length) return;
  this.$store.dispatch("startThinking");
  try {
    const sources = this.research.results
      .slice(0, 12)
      .map((r, i) =>
        `${i + 1}. ${r.title}\nURL: ${r.link}\nSnippet: ${r.snippet}`
      )
      .join("\n\n");

    const prompt = `
You are a meticulous research analyst. Read the sources and produce STRICT JSON only.

REQUIREMENTS:
- Pick a "bestAnswer" concise paragraph (<=90 words).
- Provide "reasoning" (2-4 bullets).
- Provide "steps": an ordered list of { title, url, finding, quote } where "quote" is a short exact passage from the URL or snippet to highlight.
- Provide "sources": array of { title, url } (dedupe).
- Never include markdown, backticks, or commentary—JSON only.

SOURCES:
${sources}
`.trim();

    const { text } = await AI.chat(prompt, {
      temperature: 0.2,
      max_tokens: 900,
    });

    let data;
    try {
      data = JSON.parse(text);
    } catch {
      const m = text.match(/\{[\s\S]*\}$/);
      data = m ? JSON.parse(m[0]) : null;
    }
    if (!data) {
      this.error = "AI returned an invalid summary.";
      return;
    }

    // Store & show
    this.research.summary = data.bestAnswer || "";
    this.messages.push({
      role: "assistant",
      content: data.bestAnswer || "(no answer)",
    });
    this.scrollToBottom();
    speak(this.research.summary, null, 1, 1);

    // Persist
    if (!this.currentConv) {
      const created = ArchiveAPI.create({
        mode: "research",
        userText: this.research.query,
        aiText: this.research.summary,
        keywords: ["summary", "research"],
      });
      this.currentConv = created?.id || created;
    } else {
      ArchiveAPI.appendMessage(
        this.currentConv,
        { role: "assistant", content: this.research.summary },
        ["research", "summary"]
      );
    }

    try {
      NeuralAPI &&
        NeuralAPI.ingest &&
        NeuralAPI.ingest({
          type: "web_summary",
          query: this.research.query,
          summary: this.research.summary,
        });
    } catch (e) {
      console.warn("NeuralAPI.ingest(web_summary) failed:", e);
    }

    if (this.$refs.researcher?.openSource && Array.isArray(data.steps)) {
      this.playNarratedReport(data);
    }
  } catch (e) {
    this.error = e.message || "Failed to summarize research.";
  } finally {
    this.$store.dispatch("stopResponding");
  }
},

setMode(key) {
  this.$store.commit('SET_MODE', key || 'chat');
},

    async onUserSubmit () {
      const text = (this.userInput || '').trim()
      if (!text) return

      // 1) Route research/google/search to Code 2
      const handled = await this.routeCommand(text)
      if (handled) {
        this.userInput = ''
        return
      }

      // 2) Otherwise, your normal Code 1 behavior can go here.
      // For now we just echo & stay in default mode.
      this.lastNonResearch = text
      this.setMode('default')
      this.userInput = ''
    },

    /**
     * If the command includes "research" / "google" / "search",
     * switch to Research mode and delegate to Code 2 (AiReporter)
     * without modifying Code 2.
     */
    async routeCommand (rawText) {
      const text = String(rawText || '').trim()
      if (!text) return false

      const isResearch = /\b(research|google|search)\b/i.test(text)
      if (!isResearch) return false

      // Clean query by stripping the verb prefix
      const query = text
        .replace(/^\s*(research|google|search)\s*[:,-]?\s*/i, '')
        .replace(/\s+/g, ' ')
        .trim() || text

      // Show Research UI and wait until AiReporter is mounted
      this.setMode('research')
      await this.$nextTick()

      // Delegate to Code 2 public methods — DO NOT change Code 2
      const reporter = this.$refs.researcher
      if (!reporter) {
        console.warn('AiReporter ref not ready')
        return true
      }

      try {
        // If user said "top 3", optionally use Code 2 helper
        if (/\btop\s*(3|three)\b/i.test(text) && typeof reporter.doTopGoogle3 === 'function') {
          await reporter.doTopGoogle3(query)
        } else if (typeof reporter.runReporter === 'function') {
          // Full “AI Reporter” flow: Google CSE, sources, live viewer, narration
          await reporter.runReporter(query, { forceOpen: true, speak: true })
        } else {
          console.warn('AiReporter.runReporter not found; is Code 2 mounted correctly?')
        }
      } catch (e) {
        console.error('Research delegation failed:', e)
      }

      return true
    },
  },
  
};
</script>

<style scoped>
.cogneetiv-highlight {
  background: rgba(255, 230, 0, .6);
  box-shadow: 0 0 0 2px rgba(255, 230, 0, .9);
  padding: 0 .15em;
  border-radius: .25em;
}

.active-conv-id{
  /* layout */
  display:flex;
  align-items:center;
  justify-content:center;
  margin: 10px auto 14px;
  padding: 10px 14px;
  max-width: 92%;
  text-align:center;

  /* typography */
  font-weight: 700;
  font-size: clamp(16px, 2.1vw, 20px);
  letter-spacing: .5px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  /* glassy pill + subtle border */
  background: linear-gradient(180deg, rgba(255,255,255,.07), rgba(255,255,255,.03));
  border: 1px solid rgba(255,255,255,.14);
  border-radius: 14px;

  /* neon text + glow */
  color: #e9eaff;
  text-shadow:
    0 0 6px rgba(124,108,255,.55),
    0 0 14px rgba(0,224,255,.45),
    0 2px 10px rgba(0,0,0,.35);

  /* outer glow */
  box-shadow:
    0 8px 36px rgba(0,224,255,.12),
    inset 0 0 0 1px rgba(0,224,255,.12);

  position: relative;
  isolation: isolate;
  animation: convPulse 2.6s ease-in-out infinite;
}

/* soft gradient shimmer along the top edge */
.active-conv-id::before{
  content:"";
  position:absolute;
  inset: -1px;
  border-radius: 14px;
  pointer-events:none;
  background:
    radial-gradient(60% 60% at 50% 0%, rgba(0,224,255,.22), transparent 70%),
    radial-gradient(50% 80% at 50% 120%, rgba(124,108,255,.16), transparent 70%);
  mask: linear-gradient(#000, transparent 70%);
  opacity: .9;
}

/* subtle animated pulse for attention */
@keyframes convPulse{
  0%, 100%{
    box-shadow:
      0 8px 36px rgba(0,224,255,.12),
      inset 0 0 0 1px rgba(0,224,255,.12);
    text-shadow:
      0 0 6px rgba(124,108,255,.5),
      0 0 14px rgba(0,224,255,.4),
      0 2px 10px rgba(0,0,0,.35);
  }
  50%{
    box-shadow:
      0 10px 42px rgba(0,224,255,.18),
      inset 0 0 0 1px rgba(0,224,255,.16);
    text-shadow:
      0 0 8px rgba(124,108,255,.7),
      0 0 18px rgba(0,224,255,.55),
      0 2px 10px rgba(0,0,0,.35);
  }
}

/* optional: hover raises brightness slightly */
.active-conv-id:hover{
  border-color: rgba(0,224,255,.28);
  box-shadow:
    0 12px 48px rgba(0,224,255,.2),
    inset 0 0 0 1px rgba(0,224,255,.18);
}
/* make the level clickable + glowy */
.level.level-btn{
  cursor: pointer;
  background: linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,.03));
  border: 1px solid rgba(255,255,255,.14);
  border-radius: 12px;
  padding: 18px 18px;
  transition: transform .15s ease, box-shadow .2s ease, border-color .2s ease;
}
.level.level-btn:hover{
  transform: translateY(-1px);
  border-color: rgba(0,224,255,.35);
  box-shadow: 0 6px 26px rgba(0,224,255,.18), inset 0 0 0 1px rgba(0,224,255,.12);
}
.level .bar{ margin-top: 6px; }

.live-preview{
  margin-top: 4px;
  font-size: 12px;
  opacity: .8;
  color: #cdefff;
  padding: 6px 10px;
  border-radius: 10px;
  background: rgba(0,224,255,.06);
  border: 1px solid rgba(0,224,255,.12);
}
.countdown-label { font-size: 0.85rem; opacity: 0.8; }
/* ====== Layout / Header ====== */
.wrap {
  margin-top: 0px;
  padding-block: 80px 80px 60px -80px;
  min-height: 100vh;
  background:
    radial-gradient(1200px 800px at 70% -10%, #3a2bd6 0%, rgba(0,0,0,0) 60%),
    linear-gradient(180deg, #090611, #2b1353 60%, #2a1653),
    linear-gradient(270deg, #3a2bd6, #7c6cff, #00e0ff, #00e0b8, #3a2bd6);
  background-size: 400% 400%, auto, 400% 400%;
  background-blend-mode: screen, normal, overlay;
  color: #e9eaff;
  animation: gradientShift 16s ease-in-out infinite;
}

@keyframes gradientShift {
  0%   { background-position: 0% 50%, 0 0, 0% 50%; }
  50%  { background-position: 100% 50%, 0 0, 100% 50%; }
  100% { background-position: 0% 50%, 0 0, 0% 50%; }
}

.top { display:flex; align-items:center; justify-content:space-between; padding:20px 28px; }
.brand{ display:flex; gap:12px; align-items:center; }
.brand .logo{ font-size:28px; }
.status{ display:flex; align-items:center; gap:25px; }
.level{ font-size:14px; opacity:.95 }
.bar{ width:160px; height:6px; background:rgba(255,255,255,.15); border-radius:9999px; overflow:hidden; margin-top:6px;}
.fill{ height:100%; background:linear-gradient(90deg,#7c6cff,#00e0ff); }
.btn.ghost{ padding:15px 12px; border:1px solid rgba(255,255,255,.2); border-radius:10px; color:#e9eaff; text-decoration:none; transition: .15s; margin-right: 20px; }
.btn.ghost:hover{ background:rgba(255, 255, 255, 0.519); }

/* ====== Grid ====== */
.grid{ display:grid; grid-template-columns: 500px 0.9fr; gap:28px; padding: 6px 28px 48px; }

/* ====== Modes (Sidebar) ====== */
.modes h3{ margin:8px 0 14px; opacity:.85 }
.card{
  position: relative;
  width:80%;
  background:rgba(255,255,255,.04);
  border:1px solid rgba(255,255,255,.1);
  border-radius:16px;
  padding:12px;
  display:flex; gap:12px; align-items:center;
  margin-bottom:12px;
  transition: transform .2s, box-shadow .2s, background .2s, border-color .2s;
  overflow: hidden;
}
.card.active{ box-shadow:0 0 0 2px #00e0ff66 inset; background:rgba(0,224,255,.08);   height: 160px; }
.card.open{
  transform: translateY(-1px);
  box-shadow: 0 0 0 2px #00e0ff66 inset, 0 10px 40px rgba(0,224,255,.08);
}
.card:hover{ transform: translateY(-1px); }
.icon{ font-size:20px; }
.meta b{ display:block; }
.meta small{ opacity:.85 }

/* mini mic on each card */
.mini-mic{
  margin-left:auto;
  border: 1px solid rgba(255,255,255,.25);
  background: rgba(255,255,255,.06);
  color: #fff;
  border-radius: 10px;
  padding: 4px 8px;
  cursor: pointer;
  transition: background .15s, transform .15s, border-color .15s;
}
.mini-mic:hover{
  background: rgba(0,224,255,.15);
  border-color: #00e0ff77;
  transform: translateY(-1px);
}

/* expanded body inside the active card */
.card-open-body{
  width:100%;
  margin-top: 10px;
  background: rgba(255,255,255,.04);
  border: 1px dashed rgba(255,255,255,.12);
  border-radius: 10px;
  padding: 10px;
}
.card-open-enter-active, .card-open-leave-active { transition: all .18s ease; }
.card-open-enter, .card-open-leave-to { opacity: 0; transform: translateY(-4px); }

.hint{ font-size:12px; opacity:.9; margin:0 0 8px; }
.quick-actions{ display:flex; gap:8px; }
.quick-actions .qa{
  padding:6px 10px; border-radius:8px; border:1px solid rgba(255,255,255,.2);
  background: rgba(255,255,255,.06); color:#fff; cursor:pointer;
  transition: background .15s, transform .15s, border-color .15s;
}
.quick-actions .qa:hover{ background: rgba(124,108,255,.18); border-color:#7c6cff77; transform: translateY(-1px); }

/* ====== Stage / Panel ====== */
.stage{ display:flex; flex-direction:column; align-items:center; gap:0px; margin-top: 40px;}
.panel{
  width: min(1300px, 100%); background: rgba(255,255,255,.05);
  border:1px solid rgba(255,255,255,.1); border-radius:18px; padding:14px; position:relative;
}
.panel::before{
  content:''; position:absolute; inset:-1px; border-radius:19px; pointer-events:none;
  background: radial-gradient(60% 60% at 50% 0%, rgba(0,224,255,.18), transparent 70%);
  opacity:.65; mask: linear-gradient(#000, transparent 65%);
}
.error{ background:#3b1431; border:1px solid #ff6b9e66; padding:8px 10px; border-radius:10px; color:#ffb3cc; margin-bottom:8px; }

/* ====== Chat View ====== */
.chat{ max-height: 320px; overflow:auto; margin-bottom:8px; }
.messages{ display:flex; flex-direction:column; gap:8px; }
.msg{
  max-width: 80%; padding:10px 12px; border-radius:12px;
  background: rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08);
}
.msg.user{ align-self:flex-end; background:#4e2df214; border-color:#7c6cff66; }
.msg.assistant{ align-self:flex-start; }

/* ====== Form / Inputs ====== */
.form{ display:flex; flex-direction:column; gap:8px; }
.form label{ font-size:12px; opacity:.9; display:block; }
.form input, .form select{
  width:100%; padding:12px 14px; border-radius:12px;
  background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.12);
  color:#fff; outline:none; transition: border-color .15s, box-shadow .15s, background .15s;
}
.form input:focus, .form select:focus{
  border-color:#00e0ff88; box-shadow: 0 0 0 3px rgba(0,224,255,.15); background: rgba(0,224,255,.06);
}
.row2{ display:grid; grid-template-columns: 1fr 1fr; gap:8px; }
.input{ display:flex; gap:8px; align-items:center; }
.input .icon{
  padding:0 14px; border-radius:12px; border:1px solid rgba(255,255,255,.2);
  background:rgba(255,255,255,.06); color:#fff; line-height:38px; height:40px; cursor:pointer;
  transition: background .15s, transform .15s, border-color .15s;
}
.input .icon:hover{ background: rgba(0,224,255,.15); border-color:#00e0ff77; transform: translateY(-1px); }
.viz{ margin-top:4px; border-radius:10px; background:linear-gradient(180deg, rgba(255,255,255,.03), rgba(255,255,255,.02)); border:1px solid rgba(255,255,255,.08); }

/* ====== Overlay ====== */
.overlay-mask{
  position: fixed; inset: 0; z-index: 1000;
  background: rgba(10, 5, 25, .65);
  backdrop-filter: blur(8px) saturate(120%);
  display:flex; align-items:center; justify-content:center;
  padding: 24px;
}
.overlay-card{
  width: min(1400px, 92vw);
  height: min(86vh, 900px);
  background: rgba(255,255,255,.06);
  border: 1px solid rgba(255,255,255,.12);
  border-radius: 16px;
  box-shadow: 0 40px 120px rgba(0,0,0,.45), inset 0 0 0 1px rgba(255,255,255,.06);
  display:flex; flex-direction:column; overflow:hidden;
}
.overlay-header{
  display:flex; align-items:center; justify-content:space-between;
  padding: 12px 14px; border-bottom: 1px solid rgba(255,255,255,.12);
  background: linear-gradient(180deg, rgba(0,224,255,.08), transparent 60%);
}
.overlay-header h4{ margin:0; font-weight:600; letter-spacing:.3px; }
.overlay-header .close{
  border: 1px solid rgba(255,255,255,.2);
  background: rgba(255,255,255,.06);
  color:#fff; border-radius:10px; padding:6px 10px; cursor:pointer;
}
.overlay-header .close:hover{ background: rgba(255,255,255,.12); }
.overlay-body{ flex:1; overflow:auto; }
.overlay-error{ padding: 16px; color:#ffd9e3; }

.overlay-fade-enter-active, .overlay-fade-leave-active { transition: opacity .16s ease; }
.overlay-fade-enter, .overlay-fade-leave-to { opacity: 0; }

/* ====== Responsive ====== */
@media (max-width: 960px){
  .grid{ grid-template-columns: 1fr; }
  .row2{ grid-template-columns: 1fr; }
  .panel{ padding: 12px; }
}
.overlay-title {
  font-size: 1.8rem;
  font-weight: 200;
  letter-spacing: 1.5px;
  margin: 0;
  padding: 0.25em 0.5em 0.25em 0.5em;
  border-radius: 0.5em;
  display: inline-block;
  transition: all 0.45s ease;
  position: relative;
  text-shadow: 0 0 8px rgba(255,255,255,0.25);
  margin-left: 330px;
}

/* Dashboard default */
.overlay-title {
  color: #e9eefc;
  background: linear-gradient(90deg, rgba(255,255,255,0.08), rgba(255,255,255,0.02));
  box-shadow: inset 0 0 12px rgba(255,255,255,0.1);
}

/* Archive theme */
.overlay-title.archive {
  color: #00e0ff;
  text-shadow: 0 0 10px rgba(0,224,255,0.7), 0 0 20px rgba(0,224,255,0.5);
  background: linear-gradient(90deg, rgba(0,224,255,0.15), rgba(124,108,255,0.1));
  box-shadow: inset 0 0 18px rgba(0,224,255,0.35);
  animation: glowArchive 3s ease-in-out infinite;
}

/* Neural theme */
.overlay-title.neural {
  color: #7c6cff;
  text-shadow: 0 0 12px rgba(124,108,255,0.7), 0 0 26px rgba(124,108,255,0.5);
  background: linear-gradient(90deg, rgba(124,108,255,0.18), rgba(0,224,184,0.12));
  box-shadow: inset 0 0 20px rgba(124,108,255,0.35);
  animation: glowNeural 4s linear infinite;
}

/* Animations */
@keyframes glowArchive {
  0%,100% { text-shadow: 0 0 10px rgba(0,224,255,.7), 0 0 20px rgba(0,224,255,.5); }
  50%     { text-shadow: 0 0 18px rgba(0,224,255,1), 0 0 36px rgba(0,224,255,.8); }
}
@keyframes glowNeural {
  0%   { filter: hue-rotate(0deg); }
  100% { filter: hue-rotate(360deg); }
}
.research { display: grid; gap: 12px; }
.research .research-actions { display: grid; grid-template-columns: repeat(4, minmax(0,1fr)); gap: 8px; }
.research .btn { padding: 10px 12px; border-radius: 10px; background: #2a1653; color: #dfe7ff; border: 1px solid rgba(255,255,255,.08); }
.research .btn.ghost { background: transparent; }
.google-cse-wrapper { background: rgba(255,255,255,.03); border: 1px solid rgba(255,255,255,.08); border-radius: 12px; padding: 8px; }
.results { margin-top: 10px; }
.results ul { list-style: none; padding: 0; margin: 0; display: grid; gap: 10px; }
.results li { background: rgba(255,255,255,.04); border: 1px solid rgba(255,255,255,.08); border-radius: 10px; padding: 10px 12px; }
.results a { color: #8be9ff; text-decoration: none; }
.results .snippet { color: #b6bcdf; margin: 6px 0 0; }
.image-preview { margin-top: 10px; }
.image-preview h4 { margin: 6px 0 10px; }

.image-grid {
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(400px, 1fr) );
  gap: 10px;
}
.image-cell {
  background: rgba(255,255,255,.04);
  border: 1px solid rgba(255,255,255,.08);
  border-radius: 12px;
  overflow: hidden;
  display: grid;
  grid-template-rows: 1fr auto;
}
.image-cell img {
  width: 100%;
  height: 500px;
  object-fit: cover;
  display: block;
}
.image-cell figcaption {
  display: flex;
  gap: 8px;
  padding: 8px;
  border-top: 1px solid rgba(255,255,255,.08);
}
.btn.small { padding: 6px 10px; border-radius: 8px; }
.idle-hero{
  min-height: calc(100vh - 140px);
  display: grid;
  place-items: center;
  gap: 16px;
  padding: 24px;
  position: relative;
}

/* Big mic button while idle */
.big-mic{
  display: inline-flex;
  align-items: center;
  margin-top: -220px;
  gap: 10px;
  padding: 20px 60px;
  border-radius: 9999px;
  border: 1px solid rgba(255,255,255,.18);
  background: rgba(255,255,255,.08);
  color: #e9eaff;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(0,0,0,.35);
  backdrop-filter: blur(6px) saturate(120%);
  transition: transform .15s ease, box-shadow .2s ease, border-color .2s ease, background .2s ease;
}
.big-mic:hover{
  transform: translateY(-1px);
  border-color: rgba(0,224,255,.35);
  background: rgba(0,224,255,.12);
  box-shadow: 0 16px 42px rgba(0,224,255,.18);
}

/* Live preview near the avatar */
.live-preview--avatar{
  text-align: center;
  font-size: 13px;
  opacity: .9;
  border-radius: 12px;
  padding: 8px 12px;
  background: rgba(0,224,255,.08);
  border: 1px solid rgba(0,224,255,.18);
  box-shadow: 0 8px 30px rgba(0,224,255,.12) inset;
}

/* Floating mic when UI is open (from earlier step) */
.fab-mic{
  position: absolute;
  bottom: -16px;
  right: -16px;
  z-index: 10;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 9999px;
  border: 1px solid rgba(255,255,255,.18);
  background: rgba(255,255,255,.08);
  color: #e9eaff;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(0,0,0,.35);
  backdrop-filter: blur(6px) saturate(120%);
  transition: transform .15s ease, box-shadow .2s ease, border-color .2s ease, background .2s ease;
}
.fab-mic:hover{
  transform: translateY(-1px);
  border-color: rgba(0,224,255,.35);
  background: rgba(0,224,255,.12);
  box-shadow: 0 16px 42px rgba(0,224,255,.18);
}
.fab-mic.on{
  border-color: rgba(0,224,255,.45);
  background: linear-gradient(180deg, rgba(0,224,255,.16), rgba(124,108,255,.10));
  box-shadow: 0 0 0 2px rgba(0,224,255,.28) inset, 0 18px 56px rgba(0,224,255,.22);
}
.fab-mic .label{ font-size: 14px; letter-spacing: .2px; opacity: .95; }
/* Mic arming pulse */
.big-mic.arming,
.fab-mic.arming {
  position: relative;
  box-shadow:
    0 0 0 0 rgba(0,224,255,.45),
    0 6px 18px rgba(0,0,0,.35);
  animation: mic-arm 1.2s ease-in-out infinite;
}

.big-mic.arming::after,
.fab-mic.arming::after {
  content: "";
  position: absolute;
  inset: -6px;
  border-radius: 9999px;
  box-shadow: 0 0 24px rgba(0,224,255,.55), 0 0 48px rgba(124,108,255,.35) inset;
  opacity: .75;
  pointer-events: none;
}

@keyframes mic-arm {
  0%   { transform: translateZ(0) scale(1);   box-shadow: 0 0 0 0 rgba(0,224,255,.45), 0 6px 18px rgba(0,0,0,.35); }
  70%  { transform: translateZ(0) scale(1.04); box-shadow: 0 0 0 14px rgba(0,224,255,0), 0 6px 18px rgba(0,0,0,.35); }
  100% { transform: translateZ(0) scale(1);   box-shadow: 0 0 0 0 rgba(0,224,255,0), 0 6px 18px rgba(0,0,0,.35); }
}
.idle-toggle{
  display:flex; justify-content:flex-end; gap:8px; margin:8px 12px 0;
}
.btn.ghost{
  padding:6px 10px; border:1px solid rgba(255,255,255,.2);
  border-radius:10px; background:rgba(255,255,255,.06); color:#fff;
}
.btn.ghost:hover{ background:rgba(0,224,255,.12); }

</style>